import { Component, OnDestroy, OnInit } from '@angular/core';
import { first } from 'lodash-es';
import { combineLatest, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { DesignService, VisitationService } from 'src/app/state';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'em-visitation',
  styleUrls: ['./visitation.component.less'],
  templateUrl: './visitation.component.html',
  standalone: false,
})
export class VisitationComponent implements OnInit, OnDestroy {
  public readonly designLoading$ = this.designService.loading$;
  public readonly error$ = this.visitationService.error$;
  public readonly visitationLoading$ = this.visitationService.loading$;
  public readonly visitation$ = this.visitationService.visitations$.pipe(map(first));

  public loading$ = combineLatest([this.designLoading$, this.visitationLoading$]).pipe(
    map(([designLoading, visitationLoading]) => designLoading || visitationLoading)
  );

  public siteUrl = environment.sharePointVisitationSiteUrl;

  private readonly subscriptions = new Subscription();

  public constructor(
    private readonly designService: DesignService,
    private readonly visitationService: VisitationService
  ) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit() {
    this.subscriptions.add(this.visitationService.loadByActiveEquipmentNumber().subscribe());
  }
}
